// extracted by mini-css-extract-plugin
export default {"container":"viewBody__container___TBpil"};